import { PropsWithChildren } from "react";

const Breadcrumb = ({ children }: PropsWithChildren) => (
  <div className="d-flex text-center mb-2">{children}</div>
);

export default Breadcrumb;
